import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Card, IconButton, CardContent, Typography, Grid, Divider, TextField } from '@mui/material';
import { Tooltip } from '@mui/material';
import { useEffect } from 'react';
import OverflowTooltip from '../../helpers/OverflowTooltip';
import { formatDate } from '../../helpers/handleDate';

function Documents({ employeeData }) {
    return (

        <Box
            sx={{
                // display: 'flex',
                // justifyContent: 'space-between',
                // alignItems: 'flex-start',
                // gap: 2,
                padding: 3,
                borderRadius: '10px',
                // backgroundColor: "red",
                // width: "100%"
            }}
        >
            {/* <Box sx={{ flex: 1 }}> */}
            <Grid container spacing={2} sx={{ width: "100%", margin: 0 }} >

                <Grid container spacing={2} >
                    {/* Row 1 */}
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Aadhar Number
                        </Typography>
                        <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>{employeeData?.documents.aadhar_num || 'N/A'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography
                            variant="body1"
                            style={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Passport Copy
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                style={{ color: '#000001DE', fontSize: '18px', width: '250px' }}
                            >
                                <OverflowTooltip>{employeeData?.documents.passport_file || 'N/A'}</OverflowTooltip>                                </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography
                            variant="body1"
                            style={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Offer Letter
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                style={{ color: '#000001DE', fontSize: '18px', width: '250px' }}
                            >
                                <OverflowTooltip>{employeeData?.documents.offer_letter || 'N/A'}</OverflowTooltip>
                            </Typography>

                            {/* Eye Icon */}
                            {/* <VisibilityIcon
                                sx={{ color: 'blue', fontSize: '18px', cursor: 'pointer' }}
                            /> */}
                        </Box>
                    </Grid>
                </Grid>
                {/* Row 2 */}
                <Grid container spacing={2} marginTop={{ xs: 0, sm: 2 }} >
                    {/* <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            PAN Number
                        </Typography>
                        <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>{employeeData?.documents.pan_num || 'N/A'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography
                            variant="body1"
                            style={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Transfer Letter
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                style={{ color: '#000001DE', fontSize: '18px', width: '250px' }}
                            >
                                <OverflowTooltip>{employeeData?.documents.transfer_letter || 'N/A'}</OverflowTooltip>
                            </Typography>

                            {/* Eye Icon */}
                            {/* <VisibilityIcon
                                sx={{ color: 'blue', fontSize: '18px', cursor: 'pointer' }}
                            /> */}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography
                            variant="body1"
                            style={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Resume
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                style={{ color: '#000001DE', fontSize: '18px', width: '250px' }}
                            >
                                <OverflowTooltip>{employeeData?.documents.resume || 'N/A'}</OverflowTooltip>
                            </Typography>

                            {/* Eye Icon */}
                            {/* <VisibilityIcon
                                sx={{ color: 'blue', fontSize: '18px', cursor: 'pointer' }}
                            /> */}
                        </Box>
                    </Grid>
                </Grid>


                {/* Row 3 */}
                <Grid container spacing={2} marginTop={{ xs: 0, sm: 2 }}>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Passport Number
                        </Typography>
                        <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>{employeeData?.documents.passport_num || 'N/A'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography
                            variant="body1"
                            style={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Aadhar Copy
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                style={{ color: '#000001DE', fontSize: '18px', width: '250px' }}
                            >
                                <OverflowTooltip>{employeeData?.documents.aadhar_filename || 'N/A'}</OverflowTooltip>
                            </Typography>

                            {/* Eye Icon */}
                            {/* <VisibilityIcon
                                sx={{ color: 'blue', fontSize: '18px', cursor: 'pointer' }}
                            /> */}
                        </Box>
                    </Grid>
                </Grid>

                {/* Row 4 */}
                <Grid container spacing={2} marginTop={{ xs: 0, sm: 2 }}>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Passport Valid Upto
                        </Typography>
                        <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                            {employeeData?.documents.passport_valid_upto ? formatDate(employeeData.documents.passport_valid_upto) : 'N/A'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }}>
                        <Typography
                            variant="body1"
                            style={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Pan Copy
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                style={{ color: '#000001DE', fontSize: '18px', width: '250px' }}
                            >
                                <OverflowTooltip>{employeeData?.documents.pan_filename || 'N/A'}</OverflowTooltip>
                            </Typography>

                            {/* Eye Icon */}
                            {/* <VisibilityIcon
                                sx={{ color: 'blue', fontSize: '18px', cursor: 'pointer' }}
                            /> */}
                        </Box>
                    </Grid>
                </Grid>


            </Grid>
            {/* </Box> */}
        </Box >
    )
}

export default Documents